jQuery(document).ready(function($){

  if ($('.section-page-reviews-v2').length){


   
    // Pagination & state
    let page = 1;
    const per_page = 10;
    let loading = false;
    let lastPage = false;

    var productHandle = "onefit"; // change dynamically if needed
    var $container = $("#fon-reviews-wrapper");

    var handle = $('.section-page-reviews-v2').data('handle');

    if (handle.includes('onelife')){
      productHandle = 'onelife';
    }



    // get the full hash from current page
    var hash = window.location.hash;     // e.g. "#review-2738"

    // check if it matches #review-XXXX
    var match = hash.match(/#review-(\d+)/);
    var reviewIDSelected = null;
    if (match) {
        reviewIDSelected = match[1];               // "2738"
    
        
    } else {
      // Load first page
      
    }


    // Function to fetch a single review by ID
    function fetchReviewById(reviewId) {

        if (!$('#review-highlight-' + reviewId).length){
        return $.getJSON(`https://app.usefon.com/wp-json/fon/v1/review/${reviewId}`)
            .then(function(review) {

                var nameParts = review.review_author.trim().split(" ");
                var firstName = nameParts[0];
                var lastInitial = nameParts.length > 1 ? nameParts[nameParts.length - 1][0] + "." : "";
                var displayName = `${firstName} ${lastInitial}`;

                var review_id = review.review_id;
                var review_class = review.review_image ? "with-image" : "without-image";
                var review_image_html = review.review_image
                  ? `<img class="review-image" width="400" src="${review.review_image}" alt="${displayName}"/>`
                  : "";

                var reviewHTML = `
                 <div class="col-md-6">
                    <style>
                    .review.review-highlighted {
                        border: 1px solid #0f64e1;
                    }
                    #review-${review_id}{
                      display:none;
                    }
                    </style>
                    <div id="review-highlight-${review_id}" class="review review-highlighted review-${review_class}" data-rating="${review.review_rating}">
                       <p class="display-name">${displayName}</p>
                        <div class="review-inner">
                          <div class="content">
                        
                          <p class="date">${review.review_date}</p>
                          <div class="reviewx-container">${getStarsHTML(review.review_rating)}</div>
                          <p>${review.review_content}</p>
                        </div>
                        <div class="image">${review_image_html}</div>
                      </div>
                    </div>
                `;
                $container.prepend(reviewHTML);

                var $element = $('#review-highlight-' + reviewId);

                if ($element.length) {
                    var delay = 500; // delay in milliseconds before scrolling
                    var headerHeight = 200; // optional: height of fixed header

                    setTimeout(function() {
                        $('html, body').animate({
                            scrollTop: $element.offset().top - headerHeight
                        }, 600); // 600ms smooth scroll duration
                    }, delay);
                } else {
                    console.warn('Element with ID #review-highlight-' + reviewId + ' not found.');
                }

                // Return the review object
                return response;
                
            })
            .catch(function(jqxhr, textStatus, error) {
                console.error(`Failed to fetch review ${reviewId}:`, textStatus, error);
                return null; // Return null on failure
            });
        }
    } 

    $(window).on('load', function() { // waits until the entire page is fully loaded

    loadReviews();

    });


    // Function to fetch and append reviews
    function loadReviews() {

   
      loading = true;

      $.getJSON(`https://app.usefon.com/wp-json/fon/v1/reviews-v2?product_handle=${productHandle}&page=${page}&per_page=${per_page}`)
        .done(function(response) {

          let reviews = response.reviews;

          // Update total count on first page
          if (page === 1) {
            $('.review-stats .count').html(response.total);
          }

          // No more reviews
          if (reviews.length === 0) {
            lastPage = true;
            $("#show-more-v2").hide();
            return;
          }

          // Append reviews
          reviews.forEach(function(review) {

            var nameParts = review.review_author.trim().split(" ");
            var firstName = nameParts[0];
            var lastInitial = nameParts.length > 1 ? nameParts[nameParts.length - 1][0] + "." : "";

            if (lastInitial == 'undefined'){
              lastInitial = '';
            }
            var displayName = `${firstName} ${lastInitial}`;

            // Remove extra spaces at the start/end and any extra spaces between words
            displayName = displayName.replace(/\s+/g, ' ').trim();


            var review_id = review.review_id;
            var review_class = review.review_image ? "with-image" : "without-image";
            var review_image_html = review.review_image
              ? `<img class="review-image" width="400" src="${review.review_image}" alt="${displayName}"/>`
              : "";

            var reviewHTML = `
              <div class="reviews-page-${page} col-md-6" id="review-${review_id}">
                <div  class="review review-${review_class}" data-rating="${review.review_rating}">
                    <p class="display-name">${displayName}</p>
                        <div class="review-inner">
                          <div class="content">
                        
                          <p class="date">${review.review_date}</p>
                          <div class="reviewx-container">${getStarsHTML(review.review_rating)}</div>
                          <p>${review.review_content}</p>
                        </div>
                        <div class="image">${review_image_html}</div>
                      </div>
                </div>
              </div>
            `;

            $container.append(reviewHTML);
            

            
          });

          var $element = $('.reviews-page-' + page).first(); // get the first matching element

          if ($element.length) {
            // $('html, body').animate({
            //   scrollTop: $element.offset().top - 200
            // }, 600); // 600ms for smooth scroll
          } else {
            console.warn('Element .reviews-page-' + page + ' not found.');
          }

          page++;

          if (reviewIDSelected){
            fetchReviewById(reviewIDSelected);
          }

          $(".section-page-reviews-v2").fadeIn();
          
          

        //   initPhotos();
          updateRatingBars();

          // Check if this is the last page
          if (page >= response.total_pages) {
            lastPage = true;
            $("#show-more-v2").hide();
          } else {
            $("#show-more-v2").show();
          }


        })
        .fail(function(jqxhr, textStatus, error) {
          console.error("Failed to load reviews:", textStatus, error);
        })
        .always(function() {
          loading = false;
        });
    }

    // Click: Load next page
    $(document).on("click", "#show-more-v2", function() {
      loadReviews();
    });

    // Generate stars HTML
    function getStarsHTML(ratingCount) {
      let starsHTML = '';
      for (let i = 1; i <= 5; i++) {
        const starClass = i <= ratingCount ? 'active' : 'inactive';
        starsHTML += `
          <span class="review-star ${starClass}">
            <img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Star_Symbol.png?v=1754024652" alt="">
          </span>
        `;
      }
      return starsHTML;
    }

    // // Initialize lightbox for images
    // function initPhotos(){
    //   new SimpleLightbox('.review .review-image-link');
    // }

    // Update rating histogram bars
    function updateRatingBars() {
      $('.rating-summary').each(function(){
        const rating = $(this).attr('data-get-review');
        const totalCount = $('.review[data-rating="' + rating + '"]').length;
        $(this).find('.total span').html(totalCount);

        const totalReviews = $('.review').length;
        const percentage = (totalCount / totalReviews) * 100;
        $(this).find('.bar').css('width', percentage + '%');
      });
    }

    // Filter by rating
    $('.rating-summary').on('click', function () {
      const selectedRating = $(this).attr('data-get-review');
      $('.rating-summary').removeClass('selected');
      $(this).addClass('selected');

      $('.review').parent('div').hide();
      $('.review[data-rating="'+selectedRating+'"]').parent('div').show();

      $("#show-more-v2").hide();
      $('.review-stats').removeClass('active');
    });

    // Toggle histogram panel
    $('.review-stats').on('click', function () {
      $(this).toggleClass('active');
    });

    // Toggle write review form
    $(document).on('click', '#write-a-review-v2', function(){
      $(this).toggleClass('active');
      $(this).html($(this).hasClass('active') ? 'Hide write a review form' : 'Write a review');
      $('.review-form-container').slideToggle();
    });

  }

});
